// Sidebar.js
import React, { useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Logo from "../public/aifinite-logo.svg";

// Icons
import { RiDashboardLine } from "react-icons/ri";
import { LiaBookSolid, LiaProjectDiagramSolid } from "react-icons/lia";
import { MdOutlineAssignment, MdOutlineSupportAgent } from "react-icons/md";
import { IoPersonOutline } from "react-icons/io5";
import { HiOutlineUsers } from "react-icons/hi2";
import { PiFileVideo } from "react-icons/pi";
import { IoCreateOutline } from "react-icons/io5";
import { GrUserAdmin } from "react-icons/gr";
import { GiProgression } from "react-icons/gi";

const Sidebar = ({ onLinkClick, user, token, role, setHeading, heading }) => {
  const location = useLocation();

  const isActive = (route) => {
    return location.pathname === route;
  };

  const activeStyles =
    "bg-[#FAF5FF] text-pink-800 shadow-[inset_4px_0_0_0_rgba(157,23,77,1)] no-underline";

  const inactiveStyle =
    "flex justify-between items-center gap-4 h-[55px] px-6 py-2 tracking-[0.5px] transition-all duration-300 hover:text-pink-700 hover:bg-[#f9fafb] text-[1rem] hover:tracking-[1.2px] ";

  return (
    <div
      className="z-[1] w-full flex flex-col bg-white shadow-inner border-r-1 border-gray-100  overflow-y-auto"
      style={{ height: "100vh", width: "100%" }}
    >
      <RouterLink to="/" className="w-full">
        <div
          className="w-full flex items-center justify-center p-4"
          onClick={() => setHeading("Dashboard")}
        >
          <img className="h-14 w-auto" src={Logo} alt="AIFinite Learning" />
        </div>
      </RouterLink>

      <div className="w-full overflow-y-auto">
        <RouterLink
          onClick={() => setHeading("Dashboard")}
          to="/"
          className={`${inactiveStyle} ${isActive("/") && activeStyles}`}
        >
          <RiDashboardLine className="w-[28px] h-[28px]" />
          <p className="w-full font-semibold ">Dashboard</p>
        </RouterLink>

        <RouterLink
          to="/course"
          onClick={() => {
            onLinkClick("lectures");
            setHeading("Live Sessions");
          }}
          className={`${inactiveStyle} ${
            isActive("/course") && heading === "Live Sessions" && activeStyles
          }`}
        >
          <LiaBookSolid className="w-[28px] h-[28px] " />
          <p className="w-full font-semibold ">Live Sessions</p>
        </RouterLink>

        <RouterLink
          to="/course"
          onClick={() => {
            onLinkClick("videos");
            setHeading("Videos");
          }}
          className={`${inactiveStyle} ${
            isActive("/course") && heading === "Videos" && activeStyles
          }`}
        >
          <PiFileVideo className="w-[27px] h-[27px]" />
          <p className="w-full font-semibold ">Videos</p>
        </RouterLink>

        {role && role.toLowerCase() === "admin" && (
          <>
            <RouterLink
              onClick={() => setHeading("Admin Dashboard")}
              to="/admin-dashboard"
              className={`${inactiveStyle} ${
                isActive("/admin-dashboard") && activeStyles
              }`}
            >
              <GrUserAdmin className="w-[26px] h-[26px]" />
              <p className="w-full font-semibold ">Admin Dashboard</p>
            </RouterLink>

            <RouterLink
              onClick={() => setHeading("All Lectures")}
              to="/all-lectures"
              className={`${inactiveStyle} ${
                isActive("/all-lectures") && activeStyles
              }`}
            >
              <IoCreateOutline className="w-[28px] h-[28px]" />
              <p className="w-full font-semibold ">All Lectures</p>
            </RouterLink>

            <RouterLink
              onClick={() => setHeading("Instructors")}
              to="/instructors"
              className={`${inactiveStyle} ${
                isActive("/instructors") && activeStyles
              }`}
            >
              <HiOutlineUsers className="w-[28px] h-[28px]" />
              <p className="w-full font-semibold ">Instructors</p>
            </RouterLink>
          </>
        )}

        <RouterLink
          onClick={() => setHeading("Assignments")}
          to="/assignments"
          className={`${inactiveStyle} ${
            isActive("/assignments") && activeStyles
          }`}
        >
          <MdOutlineAssignment className="w-[26px] h-[26px]" />
          <p className="w-full font-semibold ">Assignments</p>
        </RouterLink>

        <RouterLink
          onClick={() => setHeading("Projects")}
          to="/projects"
          className={`${inactiveStyle} ${
            isActive("/projects") && activeStyles
          }`}
        >
          <LiaProjectDiagramSolid className="w-[28px] h-[28px]" />
          <p className="w-full font-semibold ">Projects</p>
        </RouterLink>
        <RouterLink
          onClick={() => setHeading("Profile")}
          to="/profile"
          className={`${inactiveStyle} ${isActive("/profile") && activeStyles}`}
        >
          <IoPersonOutline className="w-[28px] h-[28px]" />
          <p className="w-full font-semibold ">Profile</p>
        </RouterLink>
        {/* <RouterLink
          onClick={() => setHeading("Code Editor")}
          to="/compiler"
          className={`${inactiveStyle} ${
            isActive("/compiler") && activeStyles
          }`}
        >
          <IoPersonOutline className="w-[28px] h-[28px]" />
          <p className="w-full font-semibold ">Code Editor</p>
        </RouterLink> */}
        {role && role.toLowerCase() === "student" && (
          <RouterLink
            onClick={() => setHeading("Support Tickets")}
            to="/support"
            className={`${inactiveStyle} ${
              isActive("/support") && activeStyles
            }`}
          >
            <MdOutlineSupportAgent className="w-[26px] h-[26px]" />
            <p className="w-full font-semibold ">Support Tickets</p>
          </RouterLink>
        )}
        {role && role.toLowerCase() === "admin" && (
          <RouterLink
            onClick={() => setHeading("Student Progress")}
            to="/student-progress"
            className={`${inactiveStyle} ${
              isActive("/student-progress") && activeStyles
            }`}
          >
            <GiProgression className="w-[26px] h-[26px]" />
            <p className="w-full font-semibold ">Student Progress</p>
          </RouterLink>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
